import React, { useState, useEffect, useRef, Component } from "react";
import styled from "styled-components";
import reorderBackground from "../assets/reorderNumpad.png";

class AsCalculatorClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: "",
      units: props.currentQuestion.units,
      displayValue: "",
      showCorrectAnswer: false,
      currentQuestion: props.currentQuestion,
      localQuestion: [], 
      update: false
    };
    this.child = React.createRef();

    this.AddNumber=this.AddNumber.bind(this);
    this.downHandler=this.downHandler.bind(this);
    //this.handleInputChange = this.handleInputChange.bind(this);
  }

  //if the question has changed blank the box
  componentDidUpdate(prevProps) {
    if (prevProps.currentQuestion != this.props.currentQuestion){
      console.log(this.props.currentAnswer);
      this.setState({units: this.props.currentQuestion.units});
      if (this.props.currentAnswer == ""){
        this.setState({answer: ""})
        this.setState({displayValue: ""});
      }else{
        this.setState({answer: this.props.currentAnswer})
        this.setState({displayValue: this.props.currentAnswer});
      }
      console.log("PROPS CHANGED");
      console.log(prevProps);
      }
  }

  componentDidMount(){
    if (this.props.currentAnswer != ""){
      this.setState({answer: this.props.currentAnswer})
      this.setState({units: this.props.currentQuestion.units});
      this.setState({displayValue: this.props.currentAnswer});
    }
  }

     
  
  AddNumber(value) {
    if (this.state.answer.length > 8)
    return;
    console.log("STATE");
    console.log(this.state);
    console.log(this);
    
    //SAVES IT IN OTHER METHOD, DONE FIRST BECAUSE STUPID SETSTATE DELAY
    this.props.onChange(this.state.answer+value.toString());
    //this.state.answer = [...this.state.answer, value];
    this.setState({answer: this.state.answer + value.toString()})
    //this.state.displayValue = this.state.answer.join("");
    this.setState({displayValue: this.state.answer});
    this.setState({ update: !this.state.update });
    console.log("DISPLAY VALUE " + this.state.displayValue);
    //setTimeOutDisplayValue();
    
  }

  SendAnswerToParent(value){
    this.props.onChange(value);
  }


  downHandler({ key }) {
    if (this.state.answer.length > 8 && key != "Delete" && key != "Backspace")
      return;
    switch (key) {
      case "1":
        this.setState({answer: this.state.answer + 1}, this.SendAnswerToParent(this.state.answer + 1))
        break;
      case "2":
        this.setState({answer: this.state.answer + 2}, this.SendAnswerToParent(this.state.answer + 2))
        break;
      case "3":
        this.setState({answer: this.state.answer + 3}, this.SendAnswerToParent(this.state.answer + 3))
        break;
      case "4":
        this.setState({answer: this.state.answer + 4}, this.SendAnswerToParent(this.state.answer + 4))
        break;
      case "5":
        this.setState({answer: this.state.answer + 5}, this.SendAnswerToParent(this.state.answer + 5))
        break;
      case "6":
        this.setState({answer: this.state.answer + 6}, this.SendAnswerToParent(this.state.answer + 6))
        break;
      case "7":
        this.setState({answer: this.state.answer + 7}, this.SendAnswerToParent(this.state.answer + 7))
        break;
      case "8":
        this.setState({answer: this.state.answer + 8}, this.SendAnswerToParent(this.state.answer + 8))
        break;
      case "9":
        this.setState({answer: this.state.answer + 9}, this.SendAnswerToParent(this.state.answer + 9))
        break;
      case "0":
        this.setState({answer: this.state.answer + 0}, this.SendAnswerToParent(this.state.answer + 0))
        break;
      case ".":
        this.setState({answer: this.state.answer + "."}, this.SendAnswerToParent(this.state.answer + "."))
        break;
        break;
      case "Backspace":
        this.setState({answer: ""},  this.SendAnswerToParent(""))
        break;
      default:
        break;
    }
   //this.props.onChange(this.state.answer);
    //this.props.onChange(this.state.answer);//do it twice just incase this works around the delay

    //this.state.displayValue = this.state.answer.join("");
    this.setState({displayValue: this.state.answer});
    this.setState({ update: !this.state.update });
    //setTimeOutDisplayValue();
  }

  

  handleInputChange(e) {
    console.log(e.target.value);
    this.setState({ value: e.target.value });
  }

  NumberWithCommas(x) {
    var output = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return output;
  }


   DefaultReturn(){
    
     //let answer = this.answer;
     //let state = this.state;
    // console.log(this.props);
     //console.log(this.state);
  
    let valueButtons = [1, 2, 3, 4, 5, 6, 7, 8, 9];
   /*
    useEffect(() => {
      window.addEventListener("keyup", downHandler);
      // Remove event listeners on cleanup
      return () => {
        window.removeEventListener("keyup", downHandler);
      };
    }, [this.displayValue]);*/
    /*
    React.useEffect(() => {
      if(props.currentQuestion != this.localQuestion) {
        console.log("called from parent");
        answer = [];
        this.displayValue = answer.join("");
        setTimeOutDisplayValue();
      }
    }, [props.currentQuestion]);
  
    useEffect(() => {
     console.log("calculator use effect");
    }, []);*/
  


    return (
      <CalculatorContainer update={this.state.update }>
      <CalculatorFrame>
        <Question
          type="text"
          disabled
        >
        <UnitsDiv>
        {this.state.units}
        </UnitsDiv>
        </Question>
            <Answer type="text" onKeyDown={this.downHandler} value={this.NumberWithCommas(this.state.answer)} />
        <Numberpad>
          {valueButtons.map(value => (
            <CalcButton
              value={value}
              onClick={() => {
                this.AddNumber(value)
                //answer = [...answer, value];
              }}
            >
              {value}
            </CalcButton>
          ))}
          <CalcButton
            value={0}
            onClick={() => {
              this.setState({answer: ""});
              this.setState({displayValue: this.state.answer});
              //setTimeOutDisplayValue();
            }}
          >
            C
          </CalcButton>
          <CalcButton
            value={0}
            onClick={() => {
              if (this.state.answer.length < 8){
                this.AddNumber(0);
              }
              //setTimeOutDisplayValue();
            }}
          >
            0
          </CalcButton>
          <CalcButton
            value={0}
            onClick={() => {
              //this.state.answer = [...this.state.answer, "."];
              this.setState({answer: this.state.answer + "."});
              this.setState({displayValue: this.state.answer});
              if (this.state.answer != ""){
                this.props.onChange(this.state.answer);
              }
              //setTimeOutDisplayValue();
            }}
          >
            .
          </CalcButton>
        </Numberpad>
      </CalculatorFrame>
    </CalculatorContainer>
    )
  }

  render(){
    return(
    this.DefaultReturn()
    )
  }
}

export default function AsCalculator({ ...props }) {
  

  return (
    <AsCalculatorClass {...props}></AsCalculatorClass>
  );
}

const UnitsDiv = styled.div`
  font-size: 0.3em;
  display: flex;
  justify-content: flex-end;
`

const CalculatorFrame = styled.div`
  width: 500px;
  height: 600px;
  display: flex;
  flex-direction: column;
  //background: rgba(255, 255, 255, 0.7);
  //border-radius: 10px;
  display: relative;
  //border: 2px solid rgb(99, 99, 99);
`;

const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Numberpad = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const OrderNumpad = styled.div`
  box-sizing: border-box;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background-image: url(${reorderBackground});
  background-size: cover;
  margin-left: 30px;
  align-self: center;
  &:hover {
    cursor: pointer;
  }
`;

const Question = styled.div`
  user-select: none;
  height: 100px;
  line-height: 50px;
  font-size: 100px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  position: relative;
  right: 100%;
  top : 25%;
`;

const Answer = styled.input`
  height: 100px;
  line-height: 50px;
  font-size: 100px;
  margin: 5px 10px;
  text-align: right;
  font-weight: 600;
  color: #000000;
  border: none;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgb(0, 0, 0);
`;

const CorrectAnswer = styled.input`
  height: 70px;
  line-height: 50px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  color: green;
`;

const CalcButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(98, 108, 113);
  border: 2px solid rgb(52, 58, 63);
  color: #ffffff;
  padding: 0.5em;
  box-sizing: border-box;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }

  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const CancelButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background: rgb(234, 29, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 29, 19, 1) 0%,
    rgba(255, 60, 50, 1) 100%
  );

  border: 2px solid rgb(234, 29, 19);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;

const OKButton = styled.div`
  text-align: center;
  width: 30%;
  height: 70px;
  margin: 5px;
  background-color: #999;
  background: rgb(25, 160, 63);
  background: linear-gradient(
    0deg,
    rgba(25, 160, 63, 1) 0%,
    rgba(43, 196, 86, 1) 100%
  );
  border: 2px solid rgb(25, 160, 63);
  color: #fff;
  user-select: none;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  font-size: 3em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }

  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;
